import { useCallback, useEffect, useState } from 'react';
import { fetchNotifications } from '../services/Notifications';
import { NotificationsResponseData } from '../types/Content';
import { translate } from '../localization';
import { hasAccessToken } from '../store/markettingContentGeneration/helpers/common';

type UseNotificationsReturn = {
  notifications: NotificationsResponseData[];
};

export const useNotifications = (): UseNotificationsReturn => {
  const [notifications, setNotifications] = useState<
    NotificationsResponseData[]
  >([]);

  const getNotifications = useCallback(async () => {
    try {
      const response = await fetchNotifications();
      const { data } = response;

      if (data?.notifications?.length) {
        const enabledNotifications = data.notifications.filter(
          notification => notification.enabled
        );
        if (enabledNotifications.length) {
          const notificationToDisplay: NotificationsResponseData[] = [];
          enabledNotifications.forEach(enabledNotification => {
            const { impactedFeatures } = enabledNotification;

            const clonedNotification: NotificationsResponseData = {
              ...enabledNotification,
            };

            if (
              Array.isArray(impactedFeatures) &&
              impactedFeatures.length > 0
            ) {
              clonedNotification.tooltip = {
                label: translate(
                  'NOTIFICATION_BANNER_AFFECTED_FEATURES_TOOLTIP'
                ),
                content: impactedFeatures.join(', '),
              };
            }

            notificationToDisplay.push(clonedNotification);
          });

          setNotifications(notificationToDisplay);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching notifications', error);
    }
  }, []);

  useEffect(() => {
    if (hasAccessToken()) {
      getNotifications();
    }
  }, []);

  return { notifications };
};
